import { SmartFormContext } from "./SmartFormContext";

(function () {
  try {
    if (window[Symbol.for("smart-form-version")] === undefined) {
      // console.error("SmartForm: Missing version");
    } else {
      const version = window[Symbol.for("smart-form-version")];
      const versionMajor = parseInt(version.split(".")[0]);
      const versionMinor = parseInt(version.split(".")[1]);
      const versionPatch = parseInt(version.split(".")[2]);
      if (versionMajor !== 2 || versionMinor <= 0 || versionPatch <= 0) {
        console.error(
          `SmartForm: Version mismatch. Expected 2.0.0, got ${version}`
        );
      }
    }
  } catch (e) {
    console.error(
      "Fatal error while validating environnement for SmartForm",
      e
    );
  }
})();

(function () {
  try {
    if (window[Symbol.for("smart-form-context")] === undefined) {
      window[Symbol.for("smart-form-context")] = SmartFormContext;
    } else {
      console.warn(
        "SmartFormContext is already defined by another import, multiple version of SmartFormContext is not supported",
        "SmartFormContext loaded previously by ",
        window[Symbol.for("smart-form-context")],
        " current is ",
        SmartFormContext
      );
    }
  } catch (e) {
    console.error(
      "Fatal error while validating environnement for SmartForm",
      e
    );
  }
})();

export * from "./FieldType.js";
export * from "./FormRender.js";
export * from "./SmartForm.js";
export * from "./SmartFormContext.js";
export * from "./SmartFormField.js";
export * from "./SmartFormSetup.js";
export * from "./useSmartForm.js";
export * from "./useSmartField.js";


